import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Alert, Form, Input, Button } from 'antd'
import {
  createRemoteDatabase,
  getRemoteDatabases,
  updateRemoteDatabase,
} from '../../common/requests'

import css from '../../common/Form.css'

export default class Cloud9Sync extends Component {
  static propTypes = {
    practiceId: PropTypes.string.isRequired,
  }

  state = {
    loading: false,
    showForm: false,
    GUID: null,
    saveSuccess: false,
  }

  componentDidMount() {
    const { practiceId } = this.props
    getRemoteDatabases(practiceId)
      .then((res) => {
        if (res.length > 0) {
          const [db] = res
          this.setState({
            remoteDbId: db.id,
            GUID: db.address,
            loading: false,
          })
        } else {
          this.showForm()
        }
      })
      .catch(() => {
        this.setState({ loading: false })
      })
  }

  showForm = () => {
    this.setState({
      showForm: true,
    })
  }

  saveGUID = () => {
    const { practiceId } = this.props
    const { remoteDbId, GUID } = this.state
    let res
    const body = {
      practice_id: practiceId,
      address: GUID,
    }
    if (remoteDbId) {
      res = updateRemoteDatabase(practiceId, remoteDbId, body)
    } else {
      res = createRemoteDatabase(practiceId, body)
    }

    res.then(() => {
      this.setState({
        loading: false,
        saveSuccess: true,
      })
    })
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleConnect = (e) => {
    e.preventDefault()
    this.setState({ loading: true })
  }

  render() {
    const {
      loading,
      saveSuccess,
      showForm,
      GUID,
    } = this.state

    return (
      <div>
        {!showForm ? (
          <div>
            <Alert
              type="success"
              message="Success"
              description="Connection previously successful"
            />
            <Button onClick={this.showForm}>Change practice GUID</Button>
          </div>
        ) : (
          <div>
            <Form onSubmit={this.handleConnect}>
              <h3>Cloud9 Sync</h3>
              <Form.Item label="Practice GUID">
                <Input
                  placeholder=""
                  value={GUID}
                  name="GUID"
                  className={css.input}
                  onChange={this.handleInputChange}
                />
              </Form.Item>
              <Button
                htmlType="submit"
                loading={loading}
                disabled={!GUID}
                type={saveSuccess ? 'primary' : null}
                onClick={this.saveGUID}
              >
                Save
              </Button>
            </Form>
            <br />
            <h3>
              IMPORTANT: Connections are only allowed at night. Please follow up
              tomorrow to finish the association step (5).
            </h3>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/AddPractice/Info/Cloud9Sync.js